import { useState } from "react";
import PageContainer from "../components/layout/PageContainer";
import GatewayLocationForm from "../components/form/GatewayLocationForm";
import { InputField } from "../components/ui/InputField";
import { MapPinIcon } from "@heroicons/react/24/solid";
import 'mapbox-gl/dist/mapbox-gl.css';

const GatewayLocationTool = () => {
  const [gatewayId, setGatewayId] = useState("");

  return (
    <>
      <PageContainer>
        <div className="mb-6 sm:mb-8 mt-1 sm:mt-1">
          <div className="flex items-center gap-2 mb-2 sm:mb-4">
            <div className="flex items-center gap-2">
              <MapPinIcon className="w-5 h-5 text-[#00FF84]" />
              <h1 className="text-xl font-bold text-white">
                Set Gateway Location
              </h1>
            </div>
          </div>
        </div>
        
        <div className="flex flex-col space-y-6">
          <p className="text-gray-400">
            Set the location for any gateway by providing its ID. Please ensure you have the correct permissions to modify the gateway's location.
          </p>

          <div className="flex flex-col space-y-2 w-80">
            <InputField
              id="gatewayId"
              label="Gateway ID"
              value={gatewayId}
              onChange={(e) => setGatewayId(e.target.value)}
              placeholder="Enter gateway ID"
            />
          </div>

          <div className="flex-1 min-h-0">
            <p className="text-gray-400">
              {gatewayId.trim() 
                ? "Please provide the precise location of the gateway. Inaccurate location may reduce your rewards. The exact location not shared publically."
                : "Once you've entered a gateway ID above, you'll be able to set the location for that gateway."
              }
            </p>
            <div className="mt-4" style={{ height: 'calc(100vh - 340px)', minHeight: '400px' }}>
              <GatewayLocationForm 
                serial={gatewayId.trim()} 
                variant="gateway" 
              />
            </div>
          </div>
        </div>
      </PageContainer>
    </>
  );
};

export default GatewayLocationTool; 